<pg-home>
  <object class="circles circle-left" type="image/svg+xml" data={circles}></object>
  <object class="circles circle-left circle-green" type="image/svg+xml" data={circlesGreen}></object>
  <object class="circles circle-right circle-green" type="image/svg+xml" data={circlesGreen}></object>

  <section id="pg-home-first-section">
    <logo animated={true}/>

    <a class="btn btn-o-white" href="#/manifesto">Manifesto</a>

    <div id="rights">
      <span>Grupo Sozo 	&#169; 2021</span>
      <span>Todos os direitos reservados</span>
    </div>
  </section>

  <script>
    import './pg-home.scss'
    import circles from '../media/circles.svg'
    import circlesGreen from '../media/circles-green.svg'

    import Logo from '../components/logo.riot'

    export default {
      circles, circlesGreen,
      state: {
        internalState: 'hi'
      },
      components: {
        Logo
      },
      onBeforeMount () {
        console.log('[home] mouting')

        // Change internal component state
        setTimeout(()=> {
          this.update({
            internalState: 'i change my value'
          })
        }, 1000)

        // Change application state (this not notify other components, you can implement an observer to that )
        setTimeout(()=> {
          this.actions.actionExample({something: 'i change too'})
          this.update()
        }, 2000)
      },
      onBeforeUpdate() {
        console.log('[home] updating')
      }
    }
  </script>
</pg-home>
